export const pfSymbolsRef = { current: [] };
export const pfSymbolsNormalizedRef = { current: [] };

/*const normalizePFSymbols = (symbols) => {
    if (!Array.isArray(symbols)) return [];

    return symbols.map(sym => {
        if (typeof sym !== "string") return sym;

        const idx = sym.indexOf("-");
        return idx === -1 ? sym : sym.substring(0, idx);
    });
};*/

export const assignPFSymbols = (data) => {
    pfSymbolsRef.current = Array.isArray(data) ? data : [];
    pfSymbolsNormalizedRef.current = Array.isArray(data) ? normalizeSymbols(data) : [];
};

// Normalizes a single symbol
export const normalizeSymbol = (sym) => {
    if (typeof sym !== "string") return sym;

    const idx = sym.indexOf("-");
    return idx === -1 ? sym : sym.substring(0, idx);
};

const normalizeSymbols = (symbols) => {
    if (!Array.isArray(symbols)) return [];
    return symbols.map(normalizeSymbol);
};

